module.exports = __webpack_public_path__ + "static/media/John Driscoll Headshot_1738575071221.a962ffcc.jpg";